module.exports = "//static.hsappstatic.net/website-grader-ui/static-1.8537/img/InterstitialBlobs.png"